import qs from 'qs';
import { RcFile } from 'antd/es/upload';
import {
    AbsenceDTO,
    AbsenceId,
    AbsencesDTO,
    AddChildDTO,
    AddCostSplitRequestDto,
    AddDiscountDTO,
    AddEmployeeUserDTO,
    AddGroupDTO,
    AddGuardianDTO,
    AdditionalCost,
    AdditionalCostSummariesDto,
    AdditionalLessonDTO,
    AdditionalLessonJournalDTO,
    AddMailThreadDTO,
    AddMessageDTO,
    AddOutOfTimetableSpecialTopicDTO,
    AddParentDTO,
    AddSpecialJournalDTO,
    AddSpecialTopicDTO,
    AddUpdateDailyScheduleDTO,
    AddUpdateDietDTO,
    AddUpdateGroupConsultationDTO,
    AddUpdateGroupTopicDTO,
    AddUpdateImportantEventDTO,
    AddUpdateInspectionDTO,
    AddUpdateMealTypeDTO,
    AddUpdateMenuDTO,
    AddUpdateParentTeacherConferenceDTO,
    AddUpdatePsychologicalHelpDTO,
    AddUpdateQualificationDTO,
    AddUpdateSpecialConsultationDTO,
    AddUpdateTripDTO,
    AddUpdateWeeklyScheduleDTO,
    BillDTO,
    CalendarEventDetailedDtos,
    CalendarEventDto,
    Child,
    ChildCostAllocation,
    ChildDetailed,
    ChildDietDTO,
    ChildId,
    ChildParent,
    ChildProfilePhotoDTO,
    ChildSettlementBalanceDTO,
    ChildSettlementId,
    ChildSettlementV2DTO,
    ChildSimpleDTO,
    ChildTransactionPayment,
    CoreCurriculumDTO,
    CostAllocationId,
    CourseId,
    CreateAbsenceDTO,
    CreateCalendarEventDto,
    CreateLessonDTO,
    CreateManualBillDto,
    CreateTransactionCostDto,
    CreateTransactionPaymentDto,
    UpdateTransactionRequest,
    DailyScheduleDTO,
    DailySpecialJournalAttendanceDTO,
    DateRange,
    DayAttendanceType,
    DietDTO,
    DietId,
    DiscountDTO,
    DiscountId,
    EditAdditionalLessonDTO,
    EditChildCostAllocation,
    EditDiscountDTO,
    EmployeeDTO,
    EmployeeId,
    EmployeeUser,
    EmployeeUserBasicInfo,
    EventId,
    EvidenceWorkingTimeDTO,
    ExtraLessonsOptionsDTO,
    FileDirectory,
    FileMetaDTO,
    GetChildrenFilters,
    GetGroupsFilters,
    GetHistoryOfChangesFilters,
    GroupConsultationDTO,
    GroupConsultationId,
    GroupDailyJournalAttendanceDTO,
    GroupDayAttendanceDTO,
    GroupDTO,
    GroupId,
    GroupTeacherDTO,
    GroupTopicDTO,
    GroupTopicId,
    GuardianId,
    GUSInformationDTO,
    HistoryChangeDTO,
    ImportantEventDTO,
    ImportantEventId,
    InspectionDTO,
    InspectionId,
    InstitutionBasicDto,
    InstitutionCreateData,
    InstitutionDto,
    InstitutionId,
    InvoiceDTO,
    JournalChildDTO,
    JournalChildWithParentsBasicInfoDto,
    JournalDTO,
    JournalId,
    JournalsFilters,
    JournalType,
    LessonDTO,
    LessonId,
    LessonsFilters,
    MailPageMessageDTO,
    MailThreadDTO,
    MailThreadId,
    MailThreadReceiversDTO,
    MailThreadsFilters,
    MealTypeDTO,
    MealTypeId,
    MenuDTO,
    MenuId,
    MessagesPaginationParams,
    MessageWithoutReceiversDTO,
    MonthlyGroupJournalAttendanceDTO,
    MonthlySpecialJournalAttendanceDTO,
    NurseryInformationDto,
    OwnerCreateData,
    OwnerDTO,
    PaginationParams,
    PaginationResponse,
    ParentId,
    ParentTeacherConferenceDTO,
    ParentTeacherConferenceId,
    PaymentDto,
    PaymentId,
    PayuCredentialsDto,
    PrincipalDTO,
    PsychologicalHelpDTO,
    PsychologicalHelpId,
    QualificationBasisDto,
    QualificationDTO,
    QualificationId,
    RemoteLessonAddUpdateDTO,
    RemoteLessonDTO,
    RemoteLessonId,
    RemoteLessonRecipientsDTO,
    RemoteLessonsFilters,
    RemoteLessonSimpleDTO,
    Role,
    RoleId,
    RolePostDTO,
    RolesSchemaDTO,
    RoleTemplate,
    SettlementChildrenSortBy,
    SettlementMealsDTO,
    SettlementOverallDTO,
    SettlementStaysDTO,
    SettlementSummaryV2SimplePageableDto,
    SettlementV2StaysDTO,
    SettlementVatRatesSettingsDto,
    SorterParams,
    SpecialAttendanceDTO,
    SpecialConsultationDTO,
    SpecialConsultationId,
    SpecialTopicDTO,
    SpecialTopicId,
    StaffSubscriptionDTO,
    SubscriptionChildrenNumbersDto,
    TimetableDTO,
    TimetableFilters,
    TimetableWorkingTimeDayDTO,
    TripDTO,
    TripId,
    UpdateAbsenceDTO,
    UpdateChildDTO,
    UpdateEmployeeUserDTO,
    UpdateGroupDayAttendanceDTO,
    UpdateGroupDTO,
    UpdateInstitutionDto,
    UpdateInvoiceDTO,
    UpdateJournalChildDatesDTO,
    UpdateLessonDTO,
    UpdateOwnerDTO,
    UpdateParentEmailDto,
    UpdatePayuCredentialsDto,
    UpdatePrincipalDTO,
    UpdateSettlementMealsDto,
    UpdateSettlementOverallDTO,
    UpdateSettlementVatRatesSettingsDto,
    UpdateSpecialJournalDTO,
    UpdateSpecialTopicDTO,
    UserId,
    WeeklyScheduleDTO,
    WithId,
    WorkingTimeCreateUpdateDTO,
    WorkingTimeDTO,
} from 'types';
import { DailyLessonAttendanceDTO } from 'types/specialAttendance/specialAttendance';
import { REQUEST_FORM_FILE } from 'consts/api/requestFormFile';
import {
    EducationalGuideTextbookId,
    EducationalGuideTextbooks,
    EducationalGuideTextbookUnits,
    EducationalGuideTopic,
    EducationalGuideTopicId,
} from 'types/educationalGuide/educationalGuide';
import omit from 'lodash/omit';
import StaffAxiosInstance from 'services/HTTPService/staff/StaffAxiosInstance';
import { CourseFullDTO, CourseUpdateDto } from 'types/course/course';
import {
    AddAutomaticCheckJournalDTO,
    AutomaticCheckJournalBasicDTO,
    AutomaticCheckJournalDetailsDTO,
    AutomaticCheckJournalId,
} from 'types/automaticCheckJournal';
import { GUS, NURSERY_REGISTRY, OWNER } from './endpoints/singleInstances';
import { ACTIVATION_EMAIL } from './endpoints/auth';
import {
    ARCHIVE_CHILD,
    CHILD_DETAILS,
    CHILD_GUARDIAN,
    CHILD_GUARDIAN_BASE,
    CHILD_LIMIT,
    CHILD_PARENT,
    CHILD_PARENT_BASE,
    CHILD_PARENT_EMAIL,
    CHILD_PROFILE_PHOTO,
    CHILDREN,
    RESTORE_CHILD,
} from './endpoints/children';
import { ARCHIVE_GROUP, GROUP, GROUPS, GROUPS_EMPLOYEES } from './endpoints/group';
import { EMPLOYEE_BY_USER_ID, EMPLOYEES } from './endpoints/employees';
import {
    ARCHIVE_JOURNAL,
    JOURNAL,
    JOURNAL_CHILD_DATES,
    JOURNAL_CHILDREN,
    JOURNAL_CHILDREN_PARENTS,
    JOURNAL_TEACHERS,
    JOURNALS,
    JOURNALS_EMPLOYEES,
    JOURNALS_GROUPS,
} from './endpoints/journals';
import { PSYCHOLOGICAL_HELP, PSYCHOLOGICAL_HELPS } from './endpoints/psychologicalHelps';
import { TRIP, TRIPS } from './endpoints/trips';
import { IMPORTANT_EVENT, IMPORTANT_EVENTS } from './endpoints/importantEvents';
import { GROUP_CONSULTATION, GROUP_CONSULTATIONS } from './endpoints/groupConsultations';
import { INSPECTION, INSPECTIONS } from './endpoints/inspections';
import { ROLE_DETAILS, ROLE_SCHEMA, ROLE_TEMPLATES, ROLES } from './endpoints/roles';
import { ADD_TEMPORARY_FILE, FILE, GET_FILES_IN_ZIP } from './endpoints/files';
import { GROUP_TOPIC, GROUP_TOPICS, GROUP_TOPICS_BY_WEEK } from './endpoints/groupTopics';
import { GROUP_DAILY_ATTENDANCE, GROUP_MONTHLY_ATTENDANCE } from './endpoints/groupAttendance';
import { DAILY_SCHEDULE, WEEKLY_SCHEDULE } from './endpoints/schedules';
import {
    PARENT_TEACHER_CONFERENCE,
    PARENT_TEACHER_CONFERENCES,
} from './endpoints/parentTeacherConferences';
import { CORE_CURRICULUMS } from './endpoints/coreCurriculums';
import {
    COMMON_JOURNALS,
    LESSON,
    LESSONS,
    LESSONS_EMPLOYEES,
    LESSONS_JOURNALS,
    LESSONS_WITHOUT_TOPIC,
    UNASSIGNED_CHILDREN,
} from './endpoints/lessons';
import { SPECIAL_CONSULTATION, SPECIAL_CONSULTATIONS } from './endpoints/specialConsultations';
import { QUALIFICATION, QUALIFICATION_CHILD, QUALIFICATIONS } from './endpoints/qualifications';
import { JOURNAL_REPORT, JOURNAL_REPORT_EXCEL, JOURNAL_REPORT_XML } from './endpoints/reports';
import {
    OUT_OF_TIMETABLE_SPECIAL_TOPICS,
    SPECIAL_TOPIC,
    SPECIAL_TOPICS,
    SPECIAL_TOPICS_BY_WEEK,
} from './endpoints/specialTopics';
import {
    SPECIAL_ATTENDANCE,
    SPECIAL_DAILY_ATTENDANCE,
    SPECIAL_MONTHLY_ATTENDANCE,
} from './endpoints/specialAttendance';
import {
    EDUCATIONAL_GUIDE_TEXTBOOK_UNITS,
    EDUCATIONAL_GUIDE_TEXTBOOKS,
    EDUCATIONAL_GUIDE_TOPIC,
} from './endpoints/educationalGuide';
import { DIET, DIETS, DIETS_CHILD } from './endpoints/diets';
import { MEAL_TYPE, MEAL_TYPES } from './endpoints/mealTypes';
import {
    MAIL_THREAD,
    MAIL_THREAD_MESSAGES,
    MAIL_THREAD_RECEIVERS,
    MAIL_THREADS,
    REPLY_MAIL_THREAD,
    SUBSCRIBE_TO_NOTIFICATIONS,
    UNREAD_MAIL_THREADS,
} from './endpoints/mailThreads';
import {
    MENU,
    MENUS,
    MENUS_GROUPS,
    MENUS_REPORTS_CATERING,
    MENUS_REPORTS_GIVEAWAY,
} from './endpoints/menus';
import { REMOTE_LESSON, REMOTE_LESSON_RECEIVERS, REMOTE_LESSONS } from './endpoints/remoteLessons';
import {
    INSTITUTION,
    INSTITUTIONS,
    INSTITUTIONS_EMPLOYEES,
    PRINCIPAL,
} from './endpoints/institutions';
import {
    PAYU_CREDENTIALS,
    SETTLEMENT_MEALS,
    SETTLEMENT_OVERALL,
    SETTLEMENT_STAYS,
    VAT_RATES,
} from './endpoints/settings';
import { DISCOUNT, DISCOUNTS } from './endpoints/discounts';
import {
    ADD_ADDITIONAL_COST,
    ADD_ADDITIONAL_COST_CORRECTION,
    ADD_CHILD_SETTLEMENT_TRANSACTION_COST,
    ADD_CHILD_SETTLEMENT_TRANSACTION_PAYMENT,
    ADD_OR_VERIFY_MONTHLY_SETTLEMENT_CORRECTION,
    ADDITIONAL_COSTS_SETTLEMENT,
    CHILD_INCOMES,
    CHILD_SETTLEMENT,
    CHILD_SETTLEMENT_BALANCE,
    CHILD_SETTLEMENT_TRANSACTION,
    COST_ALLOCATIONS,
    COST_SPLIT,
    DELETE_ADDITIONAL_COST,
    EDIT_ADDITIONAL_COST,
    EDIT_ADDITIONAL_COST_CORRECTION,
    EDIT_CHILD_SETTLEMENT_TRANSACTION,
    EXTRA_LESSON,
    EXTRA_LESSON_JOURNALS,
    EXTRA_LESSONS,
    EXTRA_LESSONS_SETTLEMENT,
    GET_MANUAL_BILL,
    IS_CHILD_SETTLEMENT_ACTIVE,
    RECALCULATE_CHILD_SETTLEMENT,
    REMOVE_CHILD_SETTLEMENT_TRANSACTION,
    SETTLEMENTS_SUMMARY_V2,
    TOGGLE_ADDITIONAL_COST_PAID,
    TOGGLE_CHILD_SETTLEMENT_PAID,
    VERIFY_ADDITIONAL_COST,
    VERIFY_CHILD_SETTLEMENT_V2,
    VERIFY_MONTHLY_SETTLEMENT_CORRECTION,
} from './endpoints/settlements';
import {
    CALENDAR_EVENT,
    CALENDAR_EVENTS,
    CALENDAR_EVENTS_DAILY,
    CALENDAR_EVENTS_MONTHLY,
} from './endpoints/calendar';
import {
    TIMETABLE_EVIDENCE_WORKING_TIME,
    TIMETABLE_EVIDENCE_WORKING_TIME_REPORT,
    TIMETABLE_WEEKLY,
    TIMETABLE_WORKING_TIME_DAILY,
    WORKING_TIME,
} from './endpoints/timetable';
import { ABSENCE, ABSENCES } from './endpoints/absences';
import { HISTORY_OF_CHANGES } from './endpoints/historyOfChanges';
import {
    GET_CORRECTION_INVOICE,
    INVOICE,
    PRINT_INVOICE,
    UPLOAD_CORRECTION_INVOICE,
} from './endpoints/invoices';
import { ACCOUNT_PACKAGE, PAYMENT_REDIRECT, PAYMENTS } from './endpoints/subscriptions';
import { COURSE, COURSES } from './endpoints/courses';
import {
    ADD_AUTOMATIC_CHECK_JOURNAL,
    AUTOMATIC_CHECK_JOURNAL_SEND_NOTIFICATION,
    AUTOMATIC_CHECK_JOURNAL_LIST,
    AUTOMATIC_CHECK_JOURNAL_DETAILS,
} from './endpoints/automaticCheckJournals';

class StaffHTTPService {
    private axios = new StaffAxiosInstance();

    public roles = {
        getRoles: () => this.axios.get<Role[]>(ROLES),
        postRoles: (roleDetails: RolePostDTO) => this.axios.post<Role>(ROLES, roleDetails),
        getRoleDetails: (roleId: RoleId) =>
            this.axios.get<Role>(ROLE_DETAILS(roleId), {
                params: { roleId },
            }),
        updateRole: ({ id, ...updatedRoleData }: Role) =>
            this.axios.put<Role>(ROLE_DETAILS(id), {
                params: { roleId: id },
                ...updatedRoleData,
            }),
        deleteRole: (roleId: RoleId) =>
            this.axios.delete(ROLE_DETAILS(roleId), {
                params: { roleId },
            }),
        getRolesTemplates: () => this.axios.get<RoleTemplate[]>(ROLE_TEMPLATES),
        getRolesSchema: () => this.axios.get<RolesSchemaDTO>(ROLE_SCHEMA),
    };

    public gus = {
        getGUSInformation: ({ regon, nip }: { regon?: string; nip?: string }) =>
            this.axios.get<GUSInformationDTO>(GUS, {
                params: { regon, nip },
            }),
    };

    public nurseryRegistry = {
        getNurseryRegistryInformation: (registryNumber: string) =>
            this.axios.get<NurseryInformationDto>(NURSERY_REGISTRY, {
                params: { registryNumber },
            }),
    };

    public owner = {
        postOwner: (body: OwnerCreateData) => this.axios.post<OwnerCreateData>(OWNER, body),
        updateOwner: (updateOwnerDTO: UpdateOwnerDTO) =>
            this.axios.put<OwnerDTO>(OWNER, updateOwnerDTO),
    };

    public authentication = {
        sendActivationEmail: (userId: UserId) => this.axios.post(ACTIVATION_EMAIL(userId)),
    };

    public employees = {
        getEmployeeByUserId: (userId: UserId) =>
            this.axios.get<EmployeeUserBasicInfo>(EMPLOYEE_BY_USER_ID(userId)),
        getEmployees: (search?: string) =>
            this.axios.get<EmployeeUser[]>(EMPLOYEES(), {
                params: { search },
            }),
        getEmployee: (employeeId: EmployeeId) =>
            this.axios.get<EmployeeUser>(EMPLOYEES(employeeId), {
                params: { employeeId },
            }),
        createEmployee: (employeeUserDTO: AddEmployeeUserDTO) =>
            this.axios.post<EmployeeUser>(EMPLOYEES(), employeeUserDTO),
        updateEmployee: ({
            employeeId,
            employeeUserDTO,
        }: {
            employeeId: EmployeeId;
            employeeUserDTO: UpdateEmployeeUserDTO;
        }) => this.axios.put<EmployeeUser>(EMPLOYEES(employeeId), employeeUserDTO),
        deleteEmployee: (employeeId: EmployeeId) =>
            this.axios.delete(EMPLOYEES(employeeId), {
                params: { employeeId },
            }),
    };

    public institutions = {
        getInstitutionDetails: (institutionId: InstitutionId) =>
            this.axios.get<InstitutionBasicDto>(INSTITUTION(institutionId)),
        updateInstitutionDetails: ({
            institutionId,
            updateInstitutionDTO,
        }: {
            institutionId: InstitutionId;
            updateInstitutionDTO: UpdateInstitutionDto;
        }) => this.axios.put<InstitutionBasicDto>(INSTITUTION(institutionId), updateInstitutionDTO),
        postInstitutions: (body: InstitutionCreateData) =>
            this.axios.post<InstitutionDto>(INSTITUTIONS, body),
        getPrincipal: (institutionId: InstitutionId) =>
            this.axios.get<PrincipalDTO>(PRINCIPAL(institutionId)),
        updatePrincipal: ({
            institutionId,
            updatePrincipalDTO,
        }: {
            institutionId: InstitutionId;
            updatePrincipalDTO: UpdatePrincipalDTO;
        }) => this.axios.patch<PrincipalDTO>(PRINCIPAL(institutionId), updatePrincipalDTO),
        getPayments: () => this.axios.get<BillDTO[]>(PAYMENTS),
        getPaymentRedirect: (billId: PaymentId) =>
            this.axios.post<PaymentDto>(PAYMENT_REDIRECT, null, { params: { billId } }),
        getInstitutionsEmployees: (institutionId: InstitutionId) =>
            this.axios.get<EmployeeDTO[]>(INSTITUTIONS_EMPLOYEES(institutionId)),
    };

    public subscription = {
        getAccountPackage: () => this.axios.get<StaffSubscriptionDTO>(ACCOUNT_PACKAGE),
    };

    public invoiceData = {
        getInvoiceData: () => this.axios.get<InvoiceDTO>(INVOICE),
        updateInvoiceData: (invoiceData: UpdateInvoiceDTO) =>
            this.axios.put<InvoiceDTO>(INVOICE, invoiceData),
    };

    public invoices = {
        getCorrectionInvoices: (correctionId: string) =>
            this.axios.get<string>(GET_CORRECTION_INVOICE(correctionId)),
        printInvoice: (invoiceId: string) =>
            this.axios.get(PRINT_INVOICE, {
                params: { invoiceId },
                responseType: 'arraybuffer',
            }),
    };

    public historyOfChanges = {
        getHistoryOfChanges: ({
            institutionId,
            filters,
            paginationParams,
        }: {
            institutionId: InstitutionId;
            filters: GetHistoryOfChangesFilters;
            paginationParams?: PaginationParams;
        }) =>
            this.axios.get<PaginationResponse<HistoryChangeDTO>>(HISTORY_OF_CHANGES, {
                params: { institutionId, ...filters, ...paginationParams },
                paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
            }),
    };

    public settings = {
        getSettlementMeals: () => this.axios.get<SettlementMealsDTO>(SETTLEMENT_MEALS),
        getSettlementStays: () => this.axios.get<SettlementV2StaysDTO>(SETTLEMENT_STAYS),
        updateSettlementMeals: ({
            settlementMealsDTO,
        }: {
            settlementMealsDTO: UpdateSettlementMealsDto;
        }) => this.axios.put<SettlementMealsDTO>(SETTLEMENT_MEALS, settlementMealsDTO),
        updateSettlementStays: ({
            settlementStaysDTO,
        }: {
            settlementStaysDTO: SettlementStaysDTO;
        }) => this.axios.put<SettlementStaysDTO>(SETTLEMENT_STAYS, settlementStaysDTO),
        getSettlementOverall: () => this.axios.get<SettlementOverallDTO>(SETTLEMENT_OVERALL),
        updateSettlementOverall: ({
            settlementOverallDTO,
        }: {
            settlementOverallDTO: UpdateSettlementOverallDTO;
        }) => this.axios.put<SettlementOverallDTO>(SETTLEMENT_OVERALL, settlementOverallDTO),
        getSettlementVatRates: () => this.axios.get<SettlementVatRatesSettingsDto>(VAT_RATES),
        updateSettlementVatRates: ({
            updateSettlementVatRatesSettingsDto,
        }: {
            updateSettlementVatRatesSettingsDto: UpdateSettlementVatRatesSettingsDto;
        }) =>
            this.axios.put<SettlementVatRatesSettingsDto>(
                VAT_RATES,
                updateSettlementVatRatesSettingsDto,
            ),
        getPayUCredentials: () => this.axios.get<PayuCredentialsDto>(PAYU_CREDENTIALS),
        updatePayUCredentials: ({
            updatePayuCredentialsDto,
        }: {
            updatePayuCredentialsDto: UpdatePayuCredentialsDto;
        }) => this.axios.put<PayuCredentialsDto>(PAYU_CREDENTIALS, updatePayuCredentialsDto),
        removePayUCredentials: () => this.axios.delete(PAYU_CREDENTIALS),
    };

    public groups = {
        getGroups: (filters?: GetGroupsFilters) =>
            this.axios.get<GroupDTO[]>(GROUPS, {
                params: filters,
            }),
        getGroup: (groupId: GroupId) => this.axios.get<GroupDTO>(GROUP(groupId)),
        archiveGroup: (groupId: GroupId) => this.axios.post(ARCHIVE_GROUP(groupId)),
        createGroup: (addGroupDTO: AddGroupDTO) => this.axios.post<GroupDTO>(GROUPS, addGroupDTO),
        updateGroup: ({
            groupId,
            updateGroupDTO,
        }: {
            groupId: GroupId;
            updateGroupDTO: UpdateGroupDTO;
        }) => this.axios.put<GroupDTO>(GROUP(groupId), updateGroupDTO),
        getGroupsEmployees: () => this.axios.get<EmployeeDTO[]>(GROUPS_EMPLOYEES),
    };

    public children = {
        getChildren: ({
            search,
            filters,
            paginationParams,
        }: {
            search?: string;
            filters?: GetChildrenFilters;
            paginationParams?: PaginationParams;
        }) =>
            this.axios.get<PaginationResponse<Child>>(CHILDREN, {
                params: { search, ...filters, ...paginationParams },
                paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
            }),
        getChild: (childId: ChildId) =>
            this.axios.get<ChildDetailed>(CHILD_DETAILS(childId), {
                params: { childId },
            }),
        getChildLimit: () => this.axios.get<SubscriptionChildrenNumbersDto>(CHILD_LIMIT),
        archiveChild: (childId: ChildId) => this.axios.post(ARCHIVE_CHILD(childId)),
        restoreChild: (childId: ChildId) => this.axios.post(RESTORE_CHILD(childId)),
        postChild: (addChildDTO: AddChildDTO) =>
            this.axios.post<{ child: Child }>(CHILDREN, addChildDTO),
        updateChild: ({
            childId,
            updateChildDTO,
        }: {
            childId: ChildId;
            updateChildDTO: UpdateChildDTO;
        }) => this.axios.put<ChildDetailed>(CHILD_DETAILS(childId), updateChildDTO),
        profilePhoto: {
            updateProfilePhoto: ({
                childId,
                childProfilePhotoDTO,
            }: {
                childId: ChildId;
                childProfilePhotoDTO: ChildProfilePhotoDTO;
            }) =>
                this.axios.put<ChildProfilePhotoDTO>(
                    CHILD_PROFILE_PHOTO(childId),
                    childProfilePhotoDTO,
                ),
            deleteProfilePhoto: ({ childId }: { childId: ChildId }) =>
                this.axios.delete(CHILD_PROFILE_PHOTO(childId)),
        },
        parent: {
            addParent: ({
                childId,
                childParent,
            }: {
                childId: ChildId;
                childParent: AddParentDTO;
            }) => this.axios.post<Child>(CHILD_PARENT_BASE(childId), childParent),
            updateParent: ({
                childId,
                parentId,
                childParent,
            }: {
                childId: ChildId;
                parentId: ParentId;
                childParent: AddParentDTO;
            }) => this.axios.put<ChildParent>(CHILD_PARENT(childId, parentId), childParent),
            updateParentEmail: ({
                childId,
                parentId,
                updateParentEmailDto,
            }: {
                childId: ChildId;
                parentId: ParentId;
                updateParentEmailDto: UpdateParentEmailDto;
            }) =>
                this.axios.put<ChildParent>(
                    CHILD_PARENT_EMAIL(childId, parentId),
                    updateParentEmailDto,
                ),
            deleteParent: ({ childId, parentId }: { childId: ChildId; parentId: ParentId }) =>
                this.axios.delete(CHILD_PARENT(childId, parentId)),
        },
        guardian: {
            addGuardian: ({
                childId,
                childGuardian,
            }: {
                childId: ChildId;
                childGuardian: AddGuardianDTO;
            }) => this.axios.post<Child>(CHILD_GUARDIAN_BASE(childId), childGuardian),
            updateGuardian: ({
                childId,
                guardianId,
                childGuardian,
            }: {
                childId: ChildId;
                guardianId: GuardianId;
                childGuardian: AddGuardianDTO;
            }) => this.axios.put<Child>(CHILD_GUARDIAN(childId, guardianId), childGuardian),
            deleteGuardian: ({
                childId,
                guardianId,
            }: {
                childId: ChildId;
                guardianId: GuardianId;
            }) => this.axios.delete<Child>(CHILD_GUARDIAN(childId, guardianId)),
        },
    };

    public journals = {
        getJournals: (filters?: JournalsFilters) =>
            this.axios.get<JournalDTO[]>(JOURNALS, { params: filters }),
        getJournal: (journalId: JournalId) => this.axios.get<JournalDTO>(JOURNAL(journalId)),
        archiveJournal: (journalId: JournalId) => this.axios.post(ARCHIVE_JOURNAL(journalId)),
        children: {
            getJournalChildren: (journalId: JournalId, datesParams?: DateRange) =>
                this.axios.get<JournalChildDTO[]>(JOURNAL_CHILDREN(journalId), {
                    params: datesParams,
                }),
            patchJournalChildDates: ({
                journalId,
                childId,
                values,
            }: {
                journalId: JournalId;
                childId: ChildId;
                values: UpdateJournalChildDatesDTO;
            }) => this.axios.patch(JOURNAL_CHILD_DATES(journalId, childId), values),
            getChildrenParents: (journalId: JournalId, datesParams?: DateRange) =>
                this.axios.get<JournalChildWithParentsBasicInfoDto[]>(
                    JOURNAL_CHILDREN_PARENTS(journalId),
                    {
                        params: datesParams,
                    },
                ),
        },
        getJournalTeachers: (journalId: JournalId, datesParams?: DateRange) =>
            this.axios.get<GroupTeacherDTO[]>(JOURNAL_TEACHERS(journalId), { params: datesParams }),
        addSpecialJournal: (specialJournalDTO: AddSpecialJournalDTO) =>
            this.axios.post<JournalDTO>(JOURNALS, specialJournalDTO),
        editSpecialJournal: ({
            journalId,
            specialJournalDTO,
        }: {
            journalId: JournalId;
            specialJournalDTO: UpdateSpecialJournalDTO;
        }) => this.axios.put<JournalDTO[]>(JOURNAL(journalId), specialJournalDTO),
        getJournalsGroups: () => this.axios.get<GroupDTO[]>(JOURNALS_GROUPS),
        getJournalsEmployees: () => this.axios.get<EmployeeDTO[]>(JOURNALS_EMPLOYEES),
    };

    public psychologicalHelps = {
        getPsychologicalHelps: (journalId: JournalId) =>
            this.axios.get<PsychologicalHelpDTO[]>(PSYCHOLOGICAL_HELPS(journalId)),
        getPsychologicalHelp: (journalId: JournalId, psychologicalHelpId: PsychologicalHelpId) =>
            this.axios.get<PsychologicalHelpDTO>(
                PSYCHOLOGICAL_HELP(journalId, psychologicalHelpId),
            ),
        addPsychologicalHelp: ({
            journalId,
            addPsychologicalHelpDTO,
        }: {
            journalId: JournalId;
            addPsychologicalHelpDTO: AddUpdatePsychologicalHelpDTO;
        }) =>
            this.axios.post<PsychologicalHelpDTO>(
                PSYCHOLOGICAL_HELPS(journalId),
                addPsychologicalHelpDTO,
            ),
        updatePsychologicalHelp: ({
            journalId,
            psychologicalHelpId,
            updatePsychologicalHelpDTO,
        }: {
            journalId: JournalId;
            psychologicalHelpId: PsychologicalHelpId;
            updatePsychologicalHelpDTO: AddUpdatePsychologicalHelpDTO;
        }) =>
            this.axios.put<PsychologicalHelpDTO>(
                PSYCHOLOGICAL_HELP(journalId, psychologicalHelpId),
                updatePsychologicalHelpDTO,
            ),
        removePsychologicalHelp: ({
            journalId,
            psychologicalHelpId,
        }: {
            journalId: JournalId;
            psychologicalHelpId: PsychologicalHelpId;
        }) => this.axios.delete(PSYCHOLOGICAL_HELP(journalId, psychologicalHelpId)),
    };

    public automaticCheckJournal = {
        getAutomaticCheckJournals: ({
            journalId,
            paginationParams,
        }: {
            journalId: JournalId;
            paginationParams?: PaginationParams;
        }) =>
            this.axios.get<PaginationResponse<AutomaticCheckJournalBasicDTO>>(
                AUTOMATIC_CHECK_JOURNAL_LIST(journalId),
                {
                    params: { ...paginationParams },
                    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
                },
            ),
        getAutomaticCheckJournal: (automaticCheckJournalId: AutomaticCheckJournalId) =>
            this.axios.get<AutomaticCheckJournalDetailsDTO>(
                AUTOMATIC_CHECK_JOURNAL_DETAILS(automaticCheckJournalId),
            ),
        addAutomaticCheckJournal: ({
            journalId,
            addAutomaticCheckJournalDTO,
        }: {
            journalId: JournalId;
            addAutomaticCheckJournalDTO: AddAutomaticCheckJournalDTO;
        }) =>
            this.axios.post(ADD_AUTOMATIC_CHECK_JOURNAL(), addAutomaticCheckJournalDTO, {
                params: { journalId },
            }),

        automaticCheckJournalSendNotification: ({
            automaticCheckJournalId,
        }: {
            journalId: JournalId;
            automaticCheckJournalId: AutomaticCheckJournalId;
        }) => this.axios.post(AUTOMATIC_CHECK_JOURNAL_SEND_NOTIFICATION(automaticCheckJournalId)),
    };

    public groupConsultations = {
        getGroupConsultations: (journalId: JournalId) =>
            this.axios.get<GroupConsultationDTO[]>(GROUP_CONSULTATIONS(journalId)),
        getGroupConsultation: (journalId: JournalId, consultationId: GroupConsultationId) =>
            this.axios.get<GroupConsultationDTO>(GROUP_CONSULTATION(journalId, consultationId)),
        addGroupConsultation: ({
            journalId,
            addGroupConsultationDTO,
        }: {
            journalId: JournalId;
            addGroupConsultationDTO: AddUpdateGroupConsultationDTO;
        }) =>
            this.axios.post<GroupConsultationDTO>(
                GROUP_CONSULTATIONS(journalId),
                addGroupConsultationDTO,
            ),
        updateGroupConsultation: ({
            journalId,
            consultationId,
            updateGroupConsultationDTO,
        }: {
            journalId: JournalId;
            consultationId: GroupConsultationId;
            updateGroupConsultationDTO: AddUpdateGroupConsultationDTO;
        }) =>
            this.axios.put<GroupConsultationDTO>(
                GROUP_CONSULTATION(journalId, consultationId),
                updateGroupConsultationDTO,
            ),
        removeGroupConsultation: ({
            journalId,
            consultationId,
        }: {
            journalId: JournalId;
            consultationId: GroupConsultationId;
        }) => this.axios.delete(GROUP_CONSULTATION(journalId, consultationId)),
    };

    public specialConsultations = {
        getSpecialConsultations: (journalId: JournalId) =>
            this.axios.get<SpecialConsultationDTO[]>(SPECIAL_CONSULTATIONS(journalId)),
        getSpecialConsultation: (journalId: JournalId, consultationId: SpecialConsultationId) =>
            this.axios.get<SpecialConsultationDTO>(SPECIAL_CONSULTATION(journalId, consultationId)),
        addSpecialConsultation: ({
            journalId,
            addSpecialConsultationDTO,
        }: {
            journalId: JournalId;
            addSpecialConsultationDTO: AddUpdateSpecialConsultationDTO;
        }) =>
            this.axios.post<SpecialConsultationDTO>(
                SPECIAL_CONSULTATIONS(journalId),
                addSpecialConsultationDTO,
            ),
        updateSpecialConsultation: ({
            journalId,
            consultationId,
            updateSpecialConsultationDTO,
        }: {
            journalId: JournalId;
            consultationId: SpecialConsultationId;
            updateSpecialConsultationDTO: AddUpdateSpecialConsultationDTO;
        }) =>
            this.axios.put<SpecialConsultationDTO>(
                SPECIAL_CONSULTATION(journalId, consultationId),
                updateSpecialConsultationDTO,
            ),
        removeSpecialConsultation: ({
            journalId,
            consultationId,
        }: {
            journalId: JournalId;
            consultationId: SpecialConsultationId;
        }) => this.axios.delete(SPECIAL_CONSULTATION(journalId, consultationId)),
    };

    public inspections = {
        getInspections: (journalId: JournalId) =>
            this.axios.get<InspectionDTO[]>(INSPECTIONS(journalId)),
        getInspection: (journalId: JournalId, inspectionId: InspectionId) =>
            this.axios.get<InspectionDTO>(INSPECTION(journalId, inspectionId)),
        addInspection: ({
            journalId,
            addInspectionDTO,
        }: {
            journalId: JournalId;
            addInspectionDTO: AddUpdateInspectionDTO;
        }) => this.axios.post<InspectionDTO>(INSPECTIONS(journalId), addInspectionDTO),
        updateInspection: ({
            journalId,
            inspectionId,
            updateInspectionDTO,
        }: {
            journalId: JournalId;
            inspectionId: InspectionId;
            updateInspectionDTO: AddUpdateInspectionDTO;
        }) =>
            this.axios.put<InspectionDTO>(INSPECTION(journalId, inspectionId), updateInspectionDTO),
        removeInspection: ({
            journalId,
            inspectionId,
        }: {
            journalId: JournalId;
            inspectionId: InspectionId;
        }) => this.axios.delete(INSPECTION(journalId, inspectionId)),
    };

    public groupTopics = {
        getGroupTopicsByWeek: (journalId: JournalId, date: string) =>
            this.axios.get<GroupTopicDTO[]>(GROUP_TOPICS_BY_WEEK(journalId), { params: { date } }),
        getGroupTopics: (journalId: JournalId, date: string) =>
            this.axios.get<GroupTopicDTO[]>(GROUP_TOPICS(journalId), { params: { date } }),
        getGroupTopic: (journalId: JournalId, groupTopicId: GroupTopicId) =>
            this.axios.get<GroupTopicDTO>(GROUP_TOPIC(journalId, groupTopicId)),
        removeGroupTopic: ({
            journalId,
            groupTopicId,
        }: {
            journalId: JournalId;
            groupTopicId: GroupTopicId;
        }) => this.axios.delete(GROUP_TOPIC(journalId, groupTopicId)),
        addGroupTopic: ({
            journalId,
            addGroupTopicDTO,
        }: {
            journalId: JournalId;
            addGroupTopicDTO: AddUpdateGroupTopicDTO;
        }) => this.axios.post<GroupTopicDTO>(GROUP_TOPICS(journalId), addGroupTopicDTO),
        editGroupTopic: ({
            journalId,
            groupTopicId,
            updateGroupTopicDTO,
        }: {
            journalId: JournalId;
            groupTopicId: GroupTopicId;
            updateGroupTopicDTO: AddUpdateGroupTopicDTO;
        }) =>
            this.axios.put<GroupTopicDTO>(
                GROUP_TOPIC(journalId, groupTopicId),
                updateGroupTopicDTO,
            ),
    };

    public specialTopics = {
        getSpecialTopicsByWeek: (journalId: JournalId, date: string) =>
            this.axios.get<SpecialTopicDTO[]>(SPECIAL_TOPICS_BY_WEEK(journalId), {
                params: { date },
            }),
        getSpecialTopics: (journalId: JournalId, date: string) =>
            this.axios.get<SpecialTopicDTO[]>(SPECIAL_TOPICS(journalId), { params: { date } }),
        getSpecialTopic: (journalId: JournalId, specialTopicId: SpecialTopicId) =>
            this.axios.get<SpecialTopicDTO>(SPECIAL_TOPIC(journalId, specialTopicId)),
        removeSpecialTopic: ({
            journalId,
            specialTopicId,
        }: {
            journalId: JournalId;
            specialTopicId: SpecialTopicId;
        }) => this.axios.delete(SPECIAL_TOPIC(journalId, specialTopicId)),
        addSpecialTopic: ({
            journalId,
            addSpecialTopicDTO,
        }: {
            journalId: JournalId;
            addSpecialTopicDTO: AddSpecialTopicDTO;
        }) => this.axios.post<SpecialTopicDTO>(SPECIAL_TOPICS(journalId), addSpecialTopicDTO),
        addOutOfTimetableSpecialTopic: ({
            journalId,
            addOutOfTimetableSpecialTopicDTO,
        }: {
            journalId: JournalId;
            addOutOfTimetableSpecialTopicDTO: AddOutOfTimetableSpecialTopicDTO;
        }) =>
            this.axios.post<SpecialTopicDTO>(
                OUT_OF_TIMETABLE_SPECIAL_TOPICS(journalId),
                addOutOfTimetableSpecialTopicDTO,
            ),
        editSpecialTopic: ({
            journalId,
            specialTopicId,
            updateSpecialTopicDTO,
        }: {
            journalId: JournalId;
            specialTopicId: SpecialTopicId;
            updateSpecialTopicDTO: UpdateSpecialTopicDTO;
        }) =>
            this.axios.put<SpecialTopicDTO>(
                SPECIAL_TOPIC(journalId, specialTopicId),
                updateSpecialTopicDTO,
            ),
    };

    public files = {
        addFile: ({
            directory,
            file,
        }: {
            directory: FileDirectory;
            file: string | Blob | RcFile;
        }) => {
            const formData = new FormData();
            formData.append(REQUEST_FORM_FILE, file);
            return this.axios.post<FileMetaDTO>(ADD_TEMPORARY_FILE, formData, {
                params: { directory },
            });
        },
        addInvoiceCorrection: ({
            correctionId,
            file,
        }: {
            correctionId: string;
            file: string | Blob | RcFile;
        }) => {
            const formData = new FormData();

            formData.append(REQUEST_FORM_FILE, file);

            return this.axios.patch<FileMetaDTO>(UPLOAD_CORRECTION_INVOICE(correctionId), formData);
        },
        getFile: (fileUri: string) =>
            this.axios.get<string>(FILE, {
                responseType: 'arraybuffer',
                params: { fileUri },
            }),
        getFilesInZip: (files: string[]) =>
            this.axios.post<string>(
                GET_FILES_IN_ZIP,
                { fileUris: files },
                {
                    responseType: 'arraybuffer',
                },
            ),
    };

    public trips = {
        getTrips: (journalId: JournalId) => this.axios.get<TripDTO[]>(TRIPS(journalId)),
        getTrip: (journalId: JournalId, tripId: TripId) =>
            this.axios.get<TripDTO>(TRIP(journalId, tripId)),
        addTrip: ({
            addTripDTO,
            journalId,
        }: {
            addTripDTO: AddUpdateTripDTO;
            journalId: JournalId;
        }) => this.axios.post<TripDTO>(TRIPS(journalId), addTripDTO),
        updateTrip: ({
            journalId,
            tripId,
            updateTripDTO,
        }: {
            journalId: JournalId;
            tripId: TripId;
            updateTripDTO: AddUpdateTripDTO;
        }) => this.axios.put<TripDTO>(TRIP(journalId, tripId), updateTripDTO),
        removeTrip: ({ journalId, tripId }: { journalId: JournalId; tripId: TripId }) =>
            this.axios.delete(TRIP(journalId, tripId)),
    };

    public coreCurriculums = {
        getCoreCurriculums: (date: string) =>
            this.axios.get<CoreCurriculumDTO[]>(CORE_CURRICULUMS, { params: { date } }),
    };

    public parentTeacherConferences = {
        getParentTeacherConferences: (journalId: JournalId) =>
            this.axios.get<ParentTeacherConferenceDTO[]>(PARENT_TEACHER_CONFERENCES(journalId)),
        getParentTeacherConference: (
            journalId: JournalId,
            parentTeacherConferenceId: ParentTeacherConferenceId,
        ) =>
            this.axios.get<ParentTeacherConferenceDTO>(
                PARENT_TEACHER_CONFERENCE(journalId, parentTeacherConferenceId),
            ),
        addParentTeacherConference: ({
            addParentTeacherConferenceDTO,
            journalId,
        }: {
            addParentTeacherConferenceDTO: AddUpdateParentTeacherConferenceDTO;
            journalId: JournalId;
        }) =>
            this.axios.post<ParentTeacherConferenceDTO>(
                PARENT_TEACHER_CONFERENCES(journalId),
                addParentTeacherConferenceDTO,
            ),
        updateParentTeacherConference: ({
            journalId,
            parentTeacherConferenceId,
            updateParentTeacherConferenceDTO,
        }: {
            journalId: JournalId;
            parentTeacherConferenceId: ParentTeacherConferenceId;
            updateParentTeacherConferenceDTO: AddUpdateParentTeacherConferenceDTO;
        }) =>
            this.axios.put<ParentTeacherConferenceDTO>(
                PARENT_TEACHER_CONFERENCE(journalId, parentTeacherConferenceId),
                updateParentTeacherConferenceDTO,
            ),
        removeParentTeacherConference: ({
            journalId,
            parentTeacherConferenceId,
        }: {
            journalId: JournalId;
            parentTeacherConferenceId: ParentTeacherConferenceId;
        }) => this.axios.delete(PARENT_TEACHER_CONFERENCE(journalId, parentTeacherConferenceId)),
    };

    public importantEvents = {
        getImportantEvents: (journalId: JournalId) =>
            this.axios.get<ImportantEventDTO[]>(IMPORTANT_EVENTS(journalId)),
        getImportantEvent: (journalId: JournalId, importantEventId: ImportantEventId) =>
            this.axios.get<ImportantEventDTO>(IMPORTANT_EVENT(journalId, importantEventId)),
        addImportantEvent: ({
            addImportantEventDTO,
            journalId,
        }: {
            addImportantEventDTO: AddUpdateImportantEventDTO;
            journalId: JournalId;
        }) => this.axios.post<ImportantEventDTO>(IMPORTANT_EVENTS(journalId), addImportantEventDTO),
        updateImportantEvent: ({
            journalId,
            importantEventId,
            updateImportantEventDTO,
        }: {
            journalId: JournalId;
            importantEventId: ImportantEventId;
            updateImportantEventDTO: AddUpdateImportantEventDTO;
        }) =>
            this.axios.put<ImportantEventDTO>(
                IMPORTANT_EVENT(journalId, importantEventId),
                updateImportantEventDTO,
            ),
        removeImportantEvent: ({
            journalId,
            importantEventId,
        }: {
            journalId: JournalId;
            importantEventId: ImportantEventId;
        }) => this.axios.delete(IMPORTANT_EVENT(journalId, importantEventId)),
    };

    public schedules = {
        dailySchedule: {
            getDailySchedule: (journalId: JournalId) =>
                this.axios.get<DailyScheduleDTO>(DAILY_SCHEDULE(journalId)),
            updateDailySchedule: ({
                journalId,
                addUpdateDailyScheduleDTO,
            }: {
                journalId: JournalId;
                addUpdateDailyScheduleDTO: AddUpdateDailyScheduleDTO;
            }) =>
                this.axios.patch<DailyScheduleDTO>(
                    DAILY_SCHEDULE(journalId),
                    addUpdateDailyScheduleDTO,
                ),
        },
        weeklySchedule: {
            getWeeklySchedule: (journalId: JournalId) =>
                this.axios.get<WeeklyScheduleDTO>(WEEKLY_SCHEDULE(journalId)),
            updateWeeklySchedule: ({
                journalId,
                addUpdateWeeklyScheduleDTO,
            }: {
                journalId: JournalId;
                addUpdateWeeklyScheduleDTO: AddUpdateWeeklyScheduleDTO;
            }) =>
                this.axios.put<WeeklyScheduleDTO>(
                    WEEKLY_SCHEDULE(journalId),
                    addUpdateWeeklyScheduleDTO,
                ),
        },
    };

    public groupAttendance = {
        getGroupDailyAttendance: (journalId: JournalId, date: string) =>
            this.axios.get<GroupDailyJournalAttendanceDTO>(GROUP_DAILY_ATTENDANCE(journalId), {
                params: { date },
            }),
        updateGroupDailyAttendance: ({
            journalId,
            childId,
            date,
            updateDayAttendanceDTO,
        }: {
            journalId: JournalId;
            childId: ChildId;
            date: string;
            updateDayAttendanceDTO: UpdateGroupDayAttendanceDTO;
        }) =>
            this.axios.put<GroupDayAttendanceDTO>(
                GROUP_DAILY_ATTENDANCE(journalId),
                updateDayAttendanceDTO,
                {
                    params: {
                        date,
                        childId,
                    },
                },
            ),
        deleteGroupDailyAttendance: ({
            journalId,
            childId,
            date,
        }: {
            journalId: JournalId;
            childId: ChildId;
            date: string;
        }) =>
            this.axios.delete(GROUP_DAILY_ATTENDANCE(journalId), {
                params: {
                    date,
                    childId,
                },
            }),
        getGroupMonthlyAttendance: (journalId: JournalId, year: number, month: number) =>
            this.axios.get<MonthlyGroupJournalAttendanceDTO>(GROUP_MONTHLY_ATTENDANCE(journalId), {
                params: { year, month },
            }),
    };

    public specialAttendance = {
        getAttendanceByLessonId: (journalId: JournalId, lessonId: LessonId) =>
            this.axios.get<DailyLessonAttendanceDTO>(SPECIAL_ATTENDANCE(journalId, lessonId)),
        getSpecialMonthlyAttendance: (journalId: JournalId, year: number, month: number) =>
            this.axios.get<MonthlySpecialJournalAttendanceDTO>(
                SPECIAL_MONTHLY_ATTENDANCE(journalId),
                {
                    params: { year, month },
                },
            ),
        getSpecialDailyAttendance: (journalId: JournalId, date: string) =>
            this.axios.get<DailySpecialJournalAttendanceDTO>(SPECIAL_DAILY_ATTENDANCE(journalId), {
                params: { date },
            }),
        updateSpecialDailyAttendance: ({
            journalId,
            childId,
            lessonId,
            type,
        }: {
            journalId: JournalId;
            lessonId: LessonId;
            childId: ChildId;
            type: DayAttendanceType;
        }) =>
            this.axios.put<SpecialAttendanceDTO>(SPECIAL_DAILY_ATTENDANCE(journalId), {
                lessonId,
                childId,
                type,
            }),
    };

    public employeeSchedule = {
        getLessons: (filters?: LessonsFilters) =>
            this.axios.get<LessonDTO[]>(LESSONS, { params: filters }),
        getLessonsWithoutTopic: ({ journalId, date }: { journalId: JournalId; date: string }) =>
            this.axios.get<LessonDTO[]>(LESSONS_WITHOUT_TOPIC, {
                params: { date, journalId },
            }),
        getEmployeeSchedule: (filters: TimetableFilters) =>
            this.axios.get<TimetableDTO>(TIMETABLE_WEEKLY, { params: filters }),
        getLesson: (id: LessonId) => this.axios.get<LessonDTO>(LESSON(id)),
        addLesson: (addLessonDTO: CreateLessonDTO) =>
            this.axios.post<LessonDTO>(LESSONS, addLessonDTO),
        editLesson: ({
            id,
            editLessonDTO,
            affectNext,
        }: {
            id: LessonId;
            editLessonDTO: UpdateLessonDTO;
            affectNext: boolean;
        }) => this.axios.put<LessonDTO>(LESSON(id), editLessonDTO, { params: { affectNext } }),
        removeLesson: ({ id, affectNext }: { id: LessonId; affectNext: boolean }) =>
            this.axios.delete(LESSON(id), { params: { affectNext } }),
        getLessonsEmployees: () => this.axios.get<EmployeeUser[]>(LESSONS_EMPLOYEES),
        getLessonsJournals: (filters?: JournalsFilters) =>
            this.axios.get<JournalDTO[]>(LESSONS_JOURNALS, { params: filters }),
        getCommonJournals: (filters?: { type?: JournalType; teacherIds: EmployeeId[] }) =>
            this.axios.get<JournalDTO[]>(COMMON_JOURNALS, {
                params: filters,
                paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
            }),
        addAbsence: (addAbsenceDTO: CreateAbsenceDTO) =>
            this.axios.post<AbsencesDTO>(ABSENCES, addAbsenceDTO),
        editAbsence: ({
            id,
            editAbsenceDTO,
        }: {
            id: AbsenceId;
            editAbsenceDTO: UpdateAbsenceDTO;
        }) => this.axios.put<AbsencesDTO>(ABSENCE(id), editAbsenceDTO),
        getAbsence: (id: AbsenceId) => this.axios.get<AbsenceDTO>(ABSENCE(id)),
        removeAbsence: (id: AbsenceId) => this.axios.delete(ABSENCE(id)),
        getWorkingTime: (date: string, search: string) =>
            this.axios.get<TimetableWorkingTimeDayDTO>(TIMETABLE_WORKING_TIME_DAILY, {
                params: { date, search },
            }),
        updateWorkingTime: ({
            teacherId,
            date,
            updateCreateWorkingTimeDTO,
        }: {
            teacherId: EmployeeId;
            date: string;
            updateCreateWorkingTimeDTO: WorkingTimeCreateUpdateDTO;
        }) =>
            this.axios.put<WorkingTimeDTO>(WORKING_TIME, {
                ...updateCreateWorkingTimeDTO,
                date,
                teacherId,
            }),
        getEvidenceWorkingTime: (selectedMonth: number, selectedYear: number, search: string) =>
            this.axios.get<EvidenceWorkingTimeDTO>(TIMETABLE_EVIDENCE_WORKING_TIME, {
                params: { month: selectedMonth, year: selectedYear, search },
            }),
        getUnassignedChildren: (lessonId: LessonId) =>
            this.axios.get<ChildSimpleDTO[]>(UNASSIGNED_CHILDREN(lessonId)),
    };

    public qualifications = {
        getQualifications: (specialJournalId: JournalId) =>
            this.axios.get<QualificationDTO[]>(QUALIFICATIONS(specialJournalId)),
        getQualification: (specialJournalId: JournalId, qualificationId: QualificationId) =>
            this.axios.get<QualificationBasisDto>(QUALIFICATION(specialJournalId, qualificationId)),
        getChildForQualification: (specialJournalId: JournalId, childId: ChildId) =>
            this.axios.get<QualificationDTO>(QUALIFICATION_CHILD(specialJournalId, childId)),
        addUpdateQualification: ({
            specialJournalId,
            addUpdateQualificationDTO,
        }: {
            specialJournalId: JournalId;
            addUpdateQualificationDTO: AddUpdateQualificationDTO;
        }) =>
            this.axios.put<QualificationDTO>(
                QUALIFICATIONS(specialJournalId),
                addUpdateQualificationDTO,
            ),
    };

    public reports = {
        getJournalReport: (journalId: JournalId) =>
            this.axios.post(JOURNAL_REPORT, null, {
                params: { journalId },
                responseType: 'arraybuffer',
            }),
        getJournalReportXML: (journalId: JournalId) =>
            this.axios.get(JOURNAL_REPORT_XML, {
                params: { journalId },
                responseType: 'arraybuffer',
            }),
        getJournalReportExcel: (journalId: JournalId) =>
            this.axios.post(JOURNAL_REPORT_EXCEL, null, {
                params: { journalId },
                responseType: 'arraybuffer',
            }),
        getEvidenceWorkingTimeReport: (selectedMonth: number, selectedYear: number) =>
            this.axios.post(TIMETABLE_EVIDENCE_WORKING_TIME_REPORT, null, {
                params: { month: selectedMonth, year: selectedYear },
                responseType: 'arraybuffer',
            }),
    };

    public educationalGuide = {
        getEducationalGuideTextbooks: (date: string) =>
            this.axios.get<EducationalGuideTextbooks>(EDUCATIONAL_GUIDE_TEXTBOOKS, {
                params: { date },
            }),
        getEducationalGuideTextbookUnits: (textbookId: EducationalGuideTextbookId) =>
            this.axios.get<EducationalGuideTextbookUnits>(
                EDUCATIONAL_GUIDE_TEXTBOOK_UNITS(textbookId),
            ),
        getEducationalGuideTopic: (topicId: EducationalGuideTopicId) =>
            this.axios.get<EducationalGuideTopic>(EDUCATIONAL_GUIDE_TOPIC(topicId)),
    };

    public diets = {
        getDiets: () => this.axios.get<DietDTO[]>(DIETS),

        getDiet: (dietId: DietId) => this.axios.get<DietDTO>(DIET(dietId)),

        addDiet: (addDietData: AddUpdateDietDTO) =>
            this.axios.post<AddUpdateDietDTO>(DIETS, addDietData),

        updateDiet: ({
            dietId,
            updateDietDTO,
        }: {
            dietId: DietId;
            updateDietDTO: AddUpdateDietDTO;
        }) => this.axios.put<DietDTO>(DIET(dietId), updateDietDTO),

        archiveDiet: (dietId: DietId) => this.axios.delete(DIET(dietId)),

        getChildDiet: (childId: ChildId) =>
            this.axios.get<ChildDietDTO>(DIETS_CHILD, {
                params: { childId },
            }),
    };

    public mealTypes = {
        getMealTypes: () => this.axios.get<MealTypeDTO[]>(MEAL_TYPES),

        getMealType: (mealTypeId: MealTypeId) => this.axios.get<MealTypeDTO>(MEAL_TYPE(mealTypeId)),

        addMealType: (addMealTypeData: AddUpdateMealTypeDTO) =>
            this.axios.post<AddUpdateMealTypeDTO>(MEAL_TYPES, addMealTypeData),

        updateMealType: ({
            mealTypeId,
            updateMealTypeDTO,
        }: {
            mealTypeId: MealTypeId;
            updateMealTypeDTO: AddUpdateMealTypeDTO;
        }) => this.axios.put<MealTypeDTO>(MEAL_TYPE(mealTypeId), updateMealTypeDTO),

        removeMealType: (mealTypeId: MealTypeId) => this.axios.delete(MEAL_TYPE(mealTypeId)),
    };

    public courses = {
        getCourses: (
            institutionId: string,
            pageable?: { page?: number; size?: number; sort?: string[] },
        ) =>
            this.axios.get<PaginationResponse<CourseFullDTO>>(COURSES, {
                params: { institutionId, ...(pageable ?? { page: 0, size: 100000 }) },
            }),
        getCourse: (courseId: string, institutionId: string) =>
            this.axios.get<CourseFullDTO>(COURSE(courseId), { params: { institutionId } }),
        addCourse: (institutionId: string, courseData: CourseUpdateDto) =>
            this.axios.post<CourseFullDTO>(COURSES, courseData, { params: { institutionId } }),
        updateCourse: (
            courseId: string | number,
            institutionId: string,
            courseData: CourseUpdateDto,
        ) =>
            this.axios.put<CourseFullDTO>(COURSE(courseId), courseData, {
                params: { institutionId },
            }),
        deleteCourse: (courseId: CourseId, institutionId: string) =>
            this.axios.delete(COURSE(courseId), { params: { institutionId } }),
    };

    public menus = {
        getMenus: ({ month, year }: { month: number; year: number }) =>
            this.axios.get<MenuDTO[]>(MENUS, { params: { month, year } }),
        getMenu: (menuId: MenuId) => this.axios.get<MenuDTO>(MENU(menuId)),
        addMenu: ({ addMenuData }: { addMenuData: AddUpdateMenuDTO }) =>
            this.axios.post<AddUpdateMenuDTO>(MENUS, { ...addMenuData }),
        updateMenu: ({
            menuId,
            updateMenuDTO,
        }: {
            menuId: MenuId;
            updateMenuDTO: AddUpdateMenuDTO;
        }) => this.axios.put<MenuDTO>(MENU(menuId), { ...updateMenuDTO }),
        removeMenu: (menuId: MenuId) => this.axios.delete(MENU(menuId)),
        getCateringReport: ({ year, month }: { year: number; month: number }) =>
            this.axios.post(MENUS_REPORTS_CATERING, null, {
                params: { year, month },
                responseType: 'arraybuffer',
            }),
        getGiveAwayReport: ({
            year,
            month,
            groupsIds,
        }: {
            year: number;
            month: number;
            groupsIds: GroupId[];
        }) =>
            this.axios.post(
                MENUS_REPORTS_GIVEAWAY,
                { groupIds: groupsIds },
                {
                    params: { year, month },
                    responseType: 'arraybuffer',
                },
            ),
        getMenusGroups: () => this.axios.get<GroupDTO[]>(MENUS_GROUPS),
    };

    public remoteLessons = {
        getRemoteLessons: (remoteLessonsFilters: RemoteLessonsFilters) =>
            this.axios.get<RemoteLessonSimpleDTO[]>(REMOTE_LESSONS, {
                params: remoteLessonsFilters,
            }),
        getRemoteLesson: (remoteLessonId: RemoteLessonId) =>
            this.axios.get<RemoteLessonDTO>(REMOTE_LESSON(remoteLessonId)),
        addRemoteLesson: (remoteLesson: RemoteLessonAddUpdateDTO) =>
            this.axios.post<RemoteLessonAddUpdateDTO>(REMOTE_LESSONS, remoteLesson),
        updateRemoteLesson: ({
            remoteLessonDTO,
            remoteLessonId,
        }: {
            remoteLessonDTO: RemoteLessonAddUpdateDTO;
            remoteLessonId: RemoteLessonId;
        }) =>
            this.axios.put<RemoteLessonAddUpdateDTO>(
                REMOTE_LESSON(remoteLessonId),
                remoteLessonDTO,
            ),
        removeRemoteLesson: (remoteLessonId: RemoteLessonId) =>
            this.axios.delete(REMOTE_LESSON(remoteLessonId)),
        getRemoteLessonRecipients: () =>
            this.axios.get<RemoteLessonRecipientsDTO>(REMOTE_LESSON_RECEIVERS),
    };

    public discounts = {
        getDiscounts: (childId: ChildId) =>
            this.axios.get<DiscountDTO[]>(DISCOUNTS, { params: { childId } }),
        addDiscount: (addDiscountData: AddDiscountDTO) =>
            this.axios.post(DISCOUNTS, addDiscountData),
        editDiscount: ({
            discountId,
            childId,
            editDiscountData,
        }: {
            discountId: DiscountId;
            childId: ChildId;
            editDiscountData: EditDiscountDTO;
        }) => this.axios.put(DISCOUNT(discountId), editDiscountData, { params: { childId } }),
        getDiscount: (discountId: DiscountId, childId: ChildId) =>
            this.axios.get<DiscountDTO>(DISCOUNT(discountId), { params: { childId } }),
        removeDiscount: ({ discountId, childId }: { discountId: DiscountId; childId: ChildId }) =>
            this.axios.delete(DISCOUNT(discountId), { params: { childId } }),
    };

    public settlements = {
        getCostAllocation: ({ costAllocationId }: { costAllocationId: CostAllocationId }) =>
            this.axios.get<ChildCostAllocation>(COST_SPLIT(costAllocationId)),
        addCostAllocation: ({ costAllocation }: { costAllocation: AddCostSplitRequestDto }) =>
            this.axios.post<ChildCostAllocation>(COST_ALLOCATIONS, costAllocation),
        editCostAllocation: ({
            costAllocation,
            costAllocationId,
        }: {
            costAllocation: EditChildCostAllocation;
            costAllocationId: string;
        }) =>
            this.axios.put<ChildCostAllocation>(
                COST_SPLIT(costAllocationId),
                omit(costAllocation, 'id'),
            ),
        removeCostAllocation: ({ costAllocationId }: { costAllocationId: CostAllocationId }) =>
            this.axios.delete(COST_SPLIT(costAllocationId)),
        getExtraLessonsByChild: (childId: ChildId) =>
            this.axios.get<ExtraLessonsOptionsDTO>(EXTRA_LESSONS, { params: { childId } }),
        getExtraLessons: ({ paginationParams }: { paginationParams?: PaginationParams }) =>
            this.axios.get<PaginationResponse<AdditionalLessonDTO>>(EXTRA_LESSONS_SETTLEMENT, {
                params: { ...paginationParams },
            }),
        getJournalsForExtraLessons: (courseId: CourseId) =>
            this.axios.get<AdditionalLessonJournalDTO[]>(EXTRA_LESSON_JOURNALS(courseId)),
        editExtraLessons: ({
            id,
            editAdditionalLessonDTO,
        }: {
            id: CourseId;
            editAdditionalLessonDTO: EditAdditionalLessonDTO;
        }) => this.axios.put<ExtraLessonsOptionsDTO>(EXTRA_LESSON(id), editAdditionalLessonDTO),
        getChildSettlementBalance: ({
            childId,
            yearMonth,
        }: {
            childId: ChildId;
            yearMonth: string;
        }) =>
            this.axios.get<ChildSettlementBalanceDTO>(CHILD_SETTLEMENT_BALANCE, {
                params: { childId, yearMonth },
            }),
        getMonthlySettlementsV2: ({
            groupIds,
            search,
            yearMonth,
            paginationParams,
            sorterParams,
        }: {
            groupIds?: GroupId[] | null;
            search?: string;
            yearMonth?: string;
            paginationParams?: PaginationParams;
            sorterParams?: SorterParams<SettlementChildrenSortBy>;
        }) =>
            this.axios.get<PaginationResponse<SettlementSummaryV2SimplePageableDto>>(
                SETTLEMENTS_SUMMARY_V2,
                {
                    params: {
                        search,
                        yearMonth,
                        groupIds,
                        pageable: { ...paginationParams, ...sorterParams },
                    },
                    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
                },
            ),
        getChildSettlement: ({ childId, period }: { childId: ChildId; period?: string }) =>
            this.axios.get<ChildSettlementV2DTO>(CHILD_SETTLEMENT, {
                params: { period, childId },
            }),
        getIsChildSettlementActive: ({
            childId,
            yearMonth,
        }: {
            childId: ChildId;
            yearMonth?: string;
        }) =>
            this.axios.get<{ active: boolean }>(IS_CHILD_SETTLEMENT_ACTIVE, {
                params: { yearMonth, childId },
            }),
        postRecalculateSettlement: ({ childId, period }: { childId: ChildId; period: string }) =>
            this.axios.post(RECALCULATE_CHILD_SETTLEMENT, {
                childId,
                period,
            }),

        verifyChildSettlement: (settlementId: ChildSettlementId) =>
            this.axios.patch(VERIFY_CHILD_SETTLEMENT_V2(settlementId), null),
        toggleChildSettlementPaid: ({
            settlementId,
            paid,
        }: {
            settlementId: ChildSettlementId;
            paid: boolean;
        }) =>
            this.axios.patch(TOGGLE_CHILD_SETTLEMENT_PAID(settlementId), null, {
                params: { paid },
            }),
        verifyChildCorrection: (correctionId: string) =>
            this.axios.patch(VERIFY_MONTHLY_SETTLEMENT_CORRECTION(correctionId), null),
        addOrCalculateChildCorrection: (settlementId: ChildSettlementId) =>
            this.axios.post(
                ADD_OR_VERIFY_MONTHLY_SETTLEMENT_CORRECTION,
                {},
                { params: { settlementId } },
            ),
        getChildIncomes: ({
            childId,
            paginationParams,
        }: {
            childId: ChildId;
            paginationParams?: PaginationParams;
        }) =>
            this.axios.get<PaginationResponse<ChildTransactionPayment>>(CHILD_INCOMES, {
                params: { childId, ...paginationParams },
            }),
        getChildTransaction: ({
            childId,
            transactionId,
        }: {
            childId: ChildId;
            transactionId: PaymentId;
        }) =>
            this.axios.get<ChildTransactionPayment>(CHILD_SETTLEMENT_TRANSACTION(transactionId), {
                params: { childId },
            }),
        addChildTransactionCost: ({
            transactionAddData,
        }: {
            transactionAddData: CreateTransactionCostDto;
        }) =>
            this.axios.post<ChildTransactionPayment>(ADD_CHILD_SETTLEMENT_TRANSACTION_COST, {
                ...transactionAddData,
            }),
        addChildTransactionPayment: ({
            transactionAddData,
        }: {
            transactionAddData: CreateTransactionPaymentDto;
        }) =>
            this.axios.post<ChildTransactionPayment>(ADD_CHILD_SETTLEMENT_TRANSACTION_PAYMENT, {
                ...transactionAddData,
            }),
        editChildTransaction: ({
            transactionId,
            transactionUpdateData,
        }: {
            transactionId: PaymentId;
            transactionUpdateData: UpdateTransactionRequest;
        }) =>
            this.axios.put<ChildTransactionPayment>(
                EDIT_CHILD_SETTLEMENT_TRANSACTION(transactionId),
                transactionUpdateData,
            ),
        removeChildTransaction: ({ transactionId }: { transactionId: PaymentId }) =>
            this.axios.post(REMOVE_CHILD_SETTLEMENT_TRANSACTION(transactionId)),
        getManualBill: ({
            additionalCostId,
            childId,
        }: {
            additionalCostId: string;
            childId: ChildId;
        }) =>
            this.axios.get<AdditionalCost>(GET_MANUAL_BILL(additionalCostId), {
                params: { childId },
            }),
        addManualBill: ({ manualBillAddData }: { manualBillAddData: CreateManualBillDto }) =>
            this.axios.post<AdditionalCost>(ADD_ADDITIONAL_COST, manualBillAddData),
        deleteAdditionalCost: ({ additionalCostId }: { additionalCostId: string }) =>
            this.axios.delete<AdditionalCost>(DELETE_ADDITIONAL_COST(additionalCostId)),
        toggleAdditionalCostPaid: ({
            additionalCostId,
            paid,
        }: {
            additionalCostId: string;
            paid: boolean;
        }) =>
            this.axios.patch(TOGGLE_ADDITIONAL_COST_PAID(additionalCostId), null, {
                params: { paid },
            }),
        verifyAdditionalCost: ({ additionalCostId }: { additionalCostId: string }) =>
            this.axios.patch<AdditionalCost>(VERIFY_ADDITIONAL_COST(additionalCostId)),
        addAdditionalCostCorrection: ({ additionalCostId }: { additionalCostId: string }) =>
            this.axios.post<AdditionalCost>(
                ADD_ADDITIONAL_COST_CORRECTION,
                {},
                {
                    params: {
                        additionalCostId,
                    },
                },
            ),
        editManualBill: ({
            additionalCostId,
            childId,
            manualBillEditData,
        }: {
            additionalCostId: string;
            childId: ChildId;
            manualBillEditData: CreateManualBillDto;
        }) =>
            this.axios.put<AdditionalCost>(
                EDIT_ADDITIONAL_COST(additionalCostId),
                manualBillEditData,
                {
                    params: { childId },
                },
            ),
        editAdditionalCostCorrection: ({
            additionalCostId,
            correctionId,
            newGrossSummaryAmount,
        }: {
            additionalCostId: string;
            correctionId: string;
            newGrossSummaryAmount: number;
        }) =>
            this.axios.patch<AdditionalCost>(
                EDIT_ADDITIONAL_COST_CORRECTION(correctionId),
                {},
                {
                    params: { additionalCostId, newGrossSummaryAmount },
                },
            ),
        getAdditionalCostsSettlement: ({ childId, period }: { childId: ChildId; period: string }) =>
            this.axios.get<AdditionalCostSummariesDto>(ADDITIONAL_COSTS_SETTLEMENT, {
                params: { childId, period },
            }),
    };

    public mailThreads = {
        getMailThreads: ({
            filters,
            paginationParams,
        }: {
            filters?: MailThreadsFilters;
            paginationParams?: PaginationParams;
        }) =>
            this.axios.get<PaginationResponse<MailThreadDTO>>(MAIL_THREADS, {
                params: { ...filters, ...paginationParams },
            }),
        getMailThread: (mailThreadId: MailThreadId) =>
            this.axios.get<MailThreadDTO>(MAIL_THREAD(mailThreadId)),
        getReplyMailThread: (mailThreadId: MailThreadId) =>
            this.axios.get<MailThreadDTO | null>(REPLY_MAIL_THREAD(mailThreadId)),
        addMailThread: (addMailThreadDTO: AddMailThreadDTO) =>
            this.axios.post<MailThreadDTO>(MAIL_THREADS, addMailThreadDTO),
        removeMailThread: (mailThreadId: MailThreadId) =>
            this.axios.delete(MAIL_THREAD(mailThreadId)),
        getMailThreadReceivers: () => this.axios.get<MailThreadReceiversDTO>(MAIL_THREAD_RECEIVERS),
        notifications: {
            subscribeToUnreadMessageNotifications: (firebaseMessagingToken: string) =>
                this.axios.post(SUBSCRIBE_TO_NOTIFICATIONS, null, {
                    params: { firebaseMessagingToken },
                }),
            getUnreadThreads: () => this.axios.get<number>(UNREAD_MAIL_THREADS),
        },
        messages: {
            addMessage: ({
                mailThreadId,
                addMessageDTO,
            }: {
                mailThreadId: MailThreadId;
                addMessageDTO: AddMessageDTO;
            }) =>
                this.axios.post<MessageWithoutReceiversDTO>(
                    MAIL_THREAD_MESSAGES(mailThreadId),
                    addMessageDTO,
                ),
            getMailThreadMessages: ({
                mailThreadId,
                paginationParams,
            }: {
                mailThreadId: MailThreadId;
                paginationParams?: MessagesPaginationParams;
            }) =>
                this.axios.get<MailPageMessageDTO>(MAIL_THREAD_MESSAGES(mailThreadId), {
                    params: { threadId: mailThreadId, ...paginationParams },
                }),
        },
    };

    public calendar = {
        getMonthlyEvents: ({ month, year }: { month: number; year: number }) =>
            this.axios.get<CalendarEventDetailedDtos>(CALENDAR_EVENTS_MONTHLY, {
                params: { month, year },
            }),
        getDailyEvents: ({ date }: { date: string }) =>
            this.axios.get<string[]>(CALENDAR_EVENTS_DAILY, {
                params: { date },
            }),
        createEvent: (addEventData: CreateCalendarEventDto) =>
            this.axios.post<CalendarEventDto>(CALENDAR_EVENTS, addEventData),
        editEvent: (editEventData: WithId<CreateCalendarEventDto>) =>
            this.axios.put<CalendarEventDto>(
                CALENDAR_EVENT(editEventData.id),
                omit(editEventData, 'id'),
            ),
        removeEvent: (eventId: EventId) => this.axios.delete(CALENDAR_EVENT(eventId)),
    };

    public utils = {
        recalculateAllSettlements: () => this.axios.patch('/api/v1/monthly-settlement/all', null),
    };
}

export default new StaffHTTPService();
